import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './store/AuthContext'; // ✅ Import the provider

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider> {/* ✅ Wrap your app with AuthProvider */}
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// Optional: Report performance
reportWebVitals();
